import { typographyClasses } from "@mui/material/Typography";
import { accordionClasses } from "@mui/material/Accordion";
import { accordionSummaryClasses } from "@mui/material/AccordionSummary";
// ----------------------------------------------------------------------
export function accordion(theme) {
    return {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    "&.MuiAccordion-root:before": {
                        backgroundColor: "white",
                        // borderTop: `1px solid var(--components-divider, #919EAB33)`,
                    },
                    "&.-MuiPaper-root-MuiAccordion-root": {},
                    // borderBottom: `1px solid var(--components-divider, #919EAB33)`,
                    boxShadow: "0px 8px 16px 0px #919EAB29",
                    [`&.${accordionClasses.expanded}`]: {
                        boxShadow: "0px 8px 16px 0px #919EAB29",
                        borderRadius: theme.shape.borderRadius,
                        backgroundColor: theme.palette.background.paper,
                    },
                    [`&.${accordionClasses.disabled}`]: {
                        backgroundColor: "transparent",
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(1),
                    borderRadius: 16,
                    boxShadow: 'none',
                    [`&.${accordionSummaryClasses.disabled}`]: {
                        opacity: 1,
                        color: theme.palette.action.disabled,
                        [`& .${typographyClasses.root}`]: {
                            color: theme.palette.success.light,
                        },
                    },
                    [`&.${accordionSummaryClasses.expanded}`]: {
                        color: theme.palette.primary.dark,
                        [`& .${typographyClasses.root}`]: {
                            color: theme.palette.primary.dark,
                        },
                    },
                },
                expandIconWrapper: {
                    color: "inherit",
                    width: "18px",
                    height: "18px",
                },
            },
        },
    };
}
